import { useInfiniteQuery, useQuery } from '@tanstack/react-query';

import { request } from '@/lib/http';
import { pagina, porCursor } from '@/lib/paginacao';
import {
  pendenciaSchema,
  type Prioridade,
  resumoPendenciasSchema,
  type TipoPendencia,
} from '@fiscoai/contracts';

export type { Prioridade };

export interface FiltrosPendencias {
  prioridade?: Prioridade;
  tipo?: TipoPendencia;
  emitidaDe?: string;
  emitidaAte?: string;
}

export function usePendencias(empresaIds: readonly string[], filtros: FiltrosPendencias) {
  return useInfiniteQuery({
    queryKey: ['pendencias', empresaIds, filtros],
    queryFn: ({ pageParam, signal }) =>
      request('/pendencias', {
        schema: pagina(pendenciaSchema),
        query: { empresaIds, ...filtros, cursor: pageParam, limit: 100 },
        signal,
      }),
    ...porCursor,
  });
}

/** Contadores por prioridade e tipo — também usados no menu e no Início. */
export function useResumoPendencias(
  empresaIds: readonly string[],
  filtros: Omit<FiltrosPendencias, 'prioridade' | 'tipo'> = {},
  habilitado = true,
) {
  return useQuery({
    queryKey: ['pendencias', 'resumo', empresaIds, filtros],
    queryFn: ({ signal }) =>
      request('/pendencias/resumo', {
        schema: resumoPendenciasSchema,
        query: { empresaIds, ...filtros },
        signal,
      }),
    enabled: habilitado,
    staleTime: 60_000,
  });
}
